var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgChart = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.367,
    height: 13.445,
    viewBox: "0 0 15.367 13.445",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "chart-line-solid",
    d: "M1.921,43.044a.481.481,0,0,0,.48.48H14.406a.96.96,0,1,1,0,1.921H2.4a2.4,2.4,0,0,1-2.4-2.4V32.96a.96.96,0,0,1,1.921,0ZM10.282,39.4a.958.958,0,0,1-1.357,0L7.2,37.681,4.52,40.361A.959.959,0,0,1,3.163,39l3.361-3.361a.958.958,0,0,1,1.357,0L9.6,37.363l3.163-3.16a.959.959,0,1,1,1.357,1.357Z",
    transform: "translate(0 -32)",
    fill: "#ffce05"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgChart);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/chart.623546035b490cb8ae5697c1567bcace.svg";